import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Button, CircleWarningIcon, Typography } from '@chilecompra/react-kit/components'

import PurchaseOrder from './PurchaseOrderChangeStatusDialog.purchaseOrders'

import routes from '../../config/settings/routes'
import { inIframe } from '../../modules/utils/inIframe'
import { topPage } from '../../modules/utils/topPage'

import { onClosePurchaseOrderChangeStatusDialog } from './PurchaseOrderChangeStatusDialog.actions'

import { Dialog, Grid, WrapperPurchaseOrder, WrapperTextFooter } from './PurchaseOrderChangeStatusDialog.styles'

/**
 * The PurchaseOrderChangeStatusDialog's container.
 */
const PurchaseOrderChangeStatusDialog = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { open, quotePurcharseOrderChangeStatus } = useSelector(state => state.purchaseOrderChangeStatusDialog)

  const isInIframe = useMemo(() => inIframe(), [])

  const handleCloseDialog = () => dispatch(onClosePurchaseOrderChangeStatusDialog())
  const handleSeeQuoteSummary = code => {
    navigate(routes.quoteSummary.replace(/:quoteId/, code))
    dispatch(onClosePurchaseOrderChangeStatusDialog())
  }

  useEffect(() => topPage(isInIframe, open), [open])

  return (
    <Dialog maxWidth="700px" onClose={handleCloseDialog} open={open} verticalAlign="top">
      <Grid container justifyContent="center" margin="32px 0 12px">
        <CircleWarningIcon fontSize="large" />
      </Grid>
      <Typography
        align="center"
        color="black1"
        fontSize="18px"
        fontWeight="bold"
        lineHeight="22px"
        margin="0 0 24px"
        padding="0 96px"
        variant="h4"
      >
        Hemos detectado cambios en tus procesos de Compra Ágil
      </Typography>
      <WrapperPurchaseOrder>
        {quotePurcharseOrderChangeStatus.map(purchaseOrder => (
          <PurchaseOrder
            code={purchaseOrder?.code}
            codePO={purchaseOrder?.codePO}
            key={purchaseOrder?.code}
            namePO={purchaseOrder?.namePO}
            onSeeQuoteSummary={handleSeeQuoteSummary}
            status={purchaseOrder?.status.toUpperCase()}
            cancelAutomatic={purchaseOrder?.cancelAutomatic}
          />
        ))}
      </WrapperPurchaseOrder>
      <WrapperTextFooter>
        <Typography
          color="black1"
          display="inline"
          fontSize="14px"
          lineHeight="18px"
          margin="0 4px 0 0"
          variant="body2"
        >
          Te informamos que puedes seleccionar otra cotización de la misma Compra Ágil en caso de cancelación por parte
          del proveedor. Recuerda revisar siempre la
        </Typography>
        <Typography
          color="black1"
          display="inline"
          fontSize="14px"
          fontWeight="bold"
          lineHeight="18px"
          margin="0 0 24px"
          variant="body2"
        >
          fecha de vigencia de cada cotización.
        </Typography>
      </WrapperTextFooter>
      <Grid container justifyContent="center">
        <Button margin="32px 0" onClick={handleCloseDialog} variant="outlined">
          Cerrar
        </Button>
      </Grid>
    </Dialog>
  )
}

export default PurchaseOrderChangeStatusDialog
